<template lang="html">
  <v-page>
    <v-topbar />
    <v-container class="mt-5">
      <v-image src="static/404.svg" />
    </v-container>
  </v-page>
</template>

<script>
export default {};
</script>

<style lang="scss">
.image {
  margin: 0 auto;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/parts/pages/404.vue